<script>
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import questionnaire from './../libs/questionnaire.json';
  import { attachScores } from './../libs/utils.js';
  
  import Footer from "./../components/Footer.svelte";
  import Godown from "./../components/Godown.svelte";
  import PrintButton from "./../components/PrintButton.svelte";

  export let id;

  let sections = attachScores(questionnaire, id);

  let percentages = sections.map(el => el.pct)
  let overall_pct = summation(percentages) / percentages.length

  function summation(array) {
      return array.reduce((tot, el) => tot + el, 0)
  }

  function score2index(score) {
    let index;
    if (score <= 40) index = 0;
    else if (score <= 60) index = 1;
    else if (score <= 80) index = 2;
    else index = 3;

    return index;
  }

  let labels = [
    $_('results.need_work'),
    $_('results.basic'),
    $_('results.good'),
    $_('results.excellent')
  ]

  let descriptions = [
    $_('results.need_work_desc'),
    $_('results.basic_desc'),
    $_('results.good_desc'),
    $_('results.excellent_desc')
  ]

  let btn_classes = [
    'btn-error',
    'btn-warning',
    'btn-info',
    'btn-success'
  ]

  let prg_classes = [
    'progress-error',
    'progress-warning',
    'progress-info',
    'progress-success'
  ]

  let r_prg_classes = [
    'text-error',
    'text-warning',
    'text-info',
    'text-success'
  ]

</script>

<div>

  <Godown target="#results"/>

  <div class="hero py-16" style="background-image: url('/assets/bg_onat.svg');">
    <div class="hero-content text-center w-full mx-8 lg:w-2/5">
      <div class="w-full">
        <h1 class="text-5xl font-bold">ONAT4All</h1>
        <p class="py-6"> {$_('results.subtitle')} </p>


        <br>

        <div class="card shadow-xl bg-base-100">
            <div class="card-body text-center">
              <progress class="progress {prg_classes[ score2index(overall_pct) ]} w-full" value="{overall_pct}" max="100"></progress>
              <h2 class="card-title block mt-8"> {$_('results.overall')}: &#8194; <u>{labels[ score2index(overall_pct) ]}</u> </h2>
              <div class="divider"></div>
              <div class="justify-around">
                <p class="text-justify leading-loose"> {$_(descriptions[ score2index(overall_pct) ])} </p>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!-- content -->
  <div id="results" class="container my-8 mx-auto w-4/5 flex flex-wrap justify-around">
    {#each sections as section}

        <div class="card overflow-visible basis-96 shadow-xl sm:mx-4 my-6 bg-neutral-content print:break-inside-avoid">
          <div class="card-body text-center">
            <h2 class="card-title block mt-0 mb-4 text-neutral"> {$_(section.section)} </h2>
            <div class="flex items-baseline justify-around">
              <div class="radial-progress mr-8 font-bold {r_prg_classes[ score2index(section.pct) ]}" style="--thickness: 5px; --value:{section.pct};">{section.pct}%</div>
              <div class="tooltip" data-tip="{descriptions[ score2index(section.pct) ]}">
                <button class="btn btn-active {btn_classes[ score2index(section.pct) ]}">{labels[ score2index(section.pct) ]}</button>
              </div>
            </div>
          </div>
        </div>

    {/each}

  </div>

  <div class="prose sm:px-0 px-4 mt-32 mb-16 mx-auto">
    <h2> {$_('results.resources')} </h2>

    {#each sections as section}
      <h3 class="px-2"> {$_(section.section)} </h3>

      {#if section.section == 'questionnaire.s_1'}
        <ul>
          <li><a href="https://www.inclusion-europe.eu/wp-content/uploads/2017/06/EN_Information_for_all.pdf" target="_blank">European standards for making information easy to read and understand</a></li>
          <li><a href="https://webunwto.s3-eu-west-1.amazonaws.com/2019-08/recommendationsaccesstourismforallenok.pdf" target="_blank">UNWTO Recommendations on Accessible Information in Tourism</a></li>
          <li><a href="https://www.w3.org/WAI/tips/designing/#provide-sufficient-contrast-between-foreground-and-background" target="_blank">Designing for Web Accessibility – Tips for Getting Started</a></li>
          <li><a href="https://webaim.org/resources/contrastchecker/" target="_blank">Contrast checker</a></li>
          <li><a href="https://wave.webaim.org/" target="_blank">Web Accessibility Evaluation Tool</a></li>
        </ul>

      {:else if section.section == 'questionnaire.s_2'}
        <ul>
          <li><a href="https://www.vtpi.org/access.pdf" target="_blank">Evaluating Accessibility for Transport Planning</a></li>
          <li><a href="https://www.accessibletourism.org/resources/enat_study-2_services_and_facilities_en.pdf" target="_blank">Services and Facilities for Accessible Tourism in Europe</a></li>
          <li><a href="https://www.itf-oecd.org/sites/default/files/docs/06tphguide.pdf" target="_blank">Improving Transport Accessibility for All</a></li>
          <li><a href="https://drive.google.com/file/d/1JXvEKz5aufF9BuJ6y1gXrahETgp3Dlvg/view?usp=sharing" target="_blank">A changing paradigm towards “Mobility for all” </a></li>
          <li>(IT) <a href="https://www.fedman.it/wp-content/uploads/2021/12/GROSSI-slides.pdf" target="_blank">STRUMENTI PER UNA MOBILITA’ SOSTENIBILE, ACCESSIBILE E INCLUSIVA</a></li>
        </ul>

      {:else if section.section == 'questionnaire.s_3'}
        <ul>
          <li><a href="https://www.scandichotels.com/explore-scandic/accessibility" target="_blank">Scandic is a good practice about Accessible accommodation</a></li>
          <li><a href="https://www.tur4all.com" target="_blank">TUR4All</a></li>
          <li>(ES) <a href="https://www.viaja.tur4all.com/wp-content/uploads/2021/07/PGA2021-05-alojamientos.pdf" target="_blank">Buenas Prácticas de Turismo Accesible</a></li>
        </ul>

      {:else if section.section == 'questionnaire.s_4'}
        <ul>
          <li><a href="https://www.3playmedia.com/blog/accessibility-guidelines-restaurants/" target="_blank">Expert-Approved Accessibility Guidelines for Restaurants, Cafes, and Eateries</a></li>
          <li><a href="https://www.rewardsnetwork.com/blog/restaurant-accessibility/" target="_blank">Restaurant Accessibility: How to Accommodate Your Guests</a></li>
          <li><a href="https://www.accessibilityguides.org/content/example-restaurant-1" target="_blank">Accessibility Guide for the Example Restaurant</a></li>
          <li><a href="https://nda.ie/publications/accessibility-toolkit" target="_blank">Make your service, buildings and websites more accessible</a></li>
          <li><a href="https://www.touchbistro.com/blog/restaurant-accessibility-guidelines/" target="_blank">Restaurant Accessibility Guidelines: Everything You Need to Know About the ADA</a></li>
          <li><a href="https://pos.toasttab.com/blog/on-the-line/restaurant-accessibility" target="_blank">How to Design an Accessible Restaurant for Diners with Disabilities</a></li>
          <li>(FR) <a href="https://www.hotelleriesuisse.ch/fr/download-A981AB1F-F798-4721-A842-523C19FC6E10.secure" target="_blank">Accessibilité dans l'hôtellerie</a></li>
          <li>(FR) <a href="https://tourisme-handicaps.org/wp-content/uploads/accessibilite_des_hotels.pdf" target="_blank">Cafés, Hôtels, Restaurants et Discothèques: réussir l'accessibilité</a></li>
        </ul>

      {:else if section.section == 'questionnaire.s_5'}
        <ul>
          <li><a href="https://www.europarc.org/tools-and-training/europarc-webinars/previous-webinars/why-and-how-to-make-nature-more-accessible" target="_blank">Why and How to make nature more accessible?</a></li>
          <li><a href="https://learning.abilityadvisor.eu/" target="_blank">The Ability Advisor</a></li>
          <li><a href="https://www.youtube.com/watch?v=mWw6Gm7ewa8" target="_blank">National Parks Association of NSW</a></li>
          <li><a href="https://www.youtube.com/watch?v=AWWQ-bUgETI" target="_blank">Inclusion in the Outdoors</a></li>
          <li><a href="https://www.visitbritain.org/sites/default/files/vb-corporate/business-hub/resources/visitor_attraction_top_10_tips_final.pdf" target="_blank">Casestudy - VisitBritain</a></li>
          <li>(FR) <a href="https://www.parcsnaturelsdewallonie.be/wp-content/uploads/2022/03/brochure-methodo-naturaccessible_bd.pdf" target="_blank">Rendre la nature accessible</a></li>
        </ul>

      {:else if section.section == 'questionnaire.s_6'}
        <ul>
          <li><a href="https://www.e-unwto.org/doi/epdf/10.18111/9789284422296" target="_blank">Inclusive Recovery Guide - Sociocultural Impacts of COVID-19</a></li>
          <li><a href="https://vimeo.com/529391464/831255d582" target="_blank">Adapting to the accessible travel market</a></li>
          <li><a href="https://www.visitbritain.org/sites/default/files/vb-corporate/dmo_guide_final.pdf" target="_blank">A guide to creating accessible destinations</a></li>
          <li><a href="https://www.visitbritain.org/sites/default/files/vb-corporate/business-hub/resources/top_10_tips_inclusive_tourism_2.pdf" target="_blank">Simple, low-cost changes to improve your accessibility</a></li>
        </ul>
      {/if}
    {/each}
  </div>

  <div class="prose sm:px-0 px-4 mt-32 mb-16 mx-auto">
    <h2> {$_('results.contacts')} </h2>
    <ul>
      <li><b>FRANCE</b> - <a href="mailto:info@ccif-marseille.com">info@ccif-marseille.com</a></li>
      <li><b>ITALY</b> - <a href="mailto:info@controvento.it">info@controvento.it</a></li>
      <li><b>SPAIN</b> - <a href="mailto:predif@predif.org">predif@predif.org</a></li>
      <li><b>IRELAND</b> - <a href="mailto:info@instructionandformation.ie">info@instructionandformation.ie</a></li>
    </ul>
  </div>

  <PrintButton/>

  <Footer/>

</div>

